/**
 * Home Page — Legacy Triangle
 * Main landing page with all sections
 */

import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import TrustSection from "../components/TrustSection";
import FundingFinder from "../components/FundingFinder";
import FundabilityPath from "../components/FundabilityPath";
import BenefitsSection from "../components/BenefitsSection";
import SuccessStories from "../components/SuccessStories";
import FAQSection from "../components/FAQSection";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Intersection Observer for fade-up animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".fade-up").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Navbar />
      <HeroSection />
      <TrustSection />
      <FundingFinder />
      <FundabilityPath />
      <BenefitsSection />
      <SuccessStories />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
